var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    'hide-controls': _vm.hideControls,
    'quiz-in-progress': _vm.isQuizInProgress
  },attrs:{"id":"appContent"}},[(this.$router.currentRoute.name !== 'quiz')?_c('TopNavi'):_vm._e(),_c('v-main',[_c('router-view')],1),(this.$router.currentRoute.name === 'quiz')?_c('QuizBottomNavi'):_c('CommonFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }